import { NotificationService } from 'src/app/signalr/notification.service';
import { Injectable, OnDestroy } from '@angular/core';
import { Util } from '@phdsoft/common';
import { environment } from 'src/environments/environment';
import { SESSION_STORAGE } from '@phdsoft/common';
import * as SignalR from '@microsoft/signalr';
import { TemplateService } from '../template/template.service';
import { AssetManager } from '../asset-manager/asset-manager';
import { NotificationModel } from 'projects/phdsoft/common/src/lib/models/notification.model';
import { checklistDatesFromApi } from '../shared/utils/calendar-day.util';

@Injectable({
  providedIn: 'root',
})
export class SignalRService implements OnDestroy {
  private hubConnection: SignalR.HubConnection;
  private currentCollection = null;
  private iscollectionSet = false;
  public connectionId: string;

  public userId: string

  constructor(
    private templateService: TemplateService,
    private assetManager: AssetManager,
    private notificationService: NotificationService
  ) { }

  ngOnDestroy(): void {
    this.stopConnection();
    console.log('stop hubConnection ondestroy');
  }

  public starConnectionAndAddTransfers() {
    // this.startConnection()
  }

  public async startConnection(assetId: string, userId: string) {
    this.userId = userId

    // This is a singleton service holding a single hubConnection. If a previous
    // connection is still open (e.g. opened by another component/dialog and never
    // stopped), it stays alive in the same group and every message is received
    // twice. Stop it before creating a new one so there is only ever one connection.
    if (!Util.isNullOrUndefined(this.hubConnection)) {
      try {
        await this.hubConnection.stop()
      } catch (err) {
        console.log('👎 Error stopping previous SignalR connection: ' + err)
      }
    }

    this.hubConnection = new SignalR.HubConnectionBuilder()
      .withAutomaticReconnect([
        0,
        2000,
        4000,
        6000,
        8000,
        15000,
        20000,
        25000,
        30000,
        35000,
        40000,
        50000,
        60000,
        70000,
      ])
      .configureLogging(SignalR.LogLevel.Debug)
      .withUrl(environment.SIGNALR_MESSAGES)
      //.withUrl('https://localhost:7086/messagehub')
      .build();

    this.hubConnection
      .start()
      .then(() => this.getConnectionId())
      .then(async () => {
        await this.joinGroup(assetId);
        console.log('🔌 Connection started');
        this.joinGroup(userId);
        this.listeners();
      })
      .catch((err) => console.log('👎 Error while starting connection: ' + err));


    this.hubConnection.onclose((error) => {
      console.log('🔌 SignalR connection closed');
    });

    this.hubConnection.onreconnected((connectionId) => {
      this.joinGroup(userId)
        .then(async () => {
          await this.joinGroup(assetId);
          console.log('🔌 SignalR reconnected');
        })
        .catch((err) => console.log(`👎 Error while reconnected: ${err}`));
    });
  }

  private listeners(): void {
    this.addTransferPointsDataListener();
    this.addTransferPointsStatusListener();
    this.addTransferspreadhsheetStatusListener();
    this.addTransferspreadhsheetImporterStatusListener();
    this.addTransferNeutralFileDataListener();
    this.addNotificationsListener();
    this.addConsoleListener();
  }

  public addConsoleListener = () => {
    this.hubConnection.on("consoleMessage", (message) => {
      console.log(message)
    });
  }

  public addTransferPointsDataListener = () => {
    if (this.isConnectionAlive()) {
      this.hubConnection.on('transferpointsdata', (data) => {
        {
          // Inspection points pushed here skip the HTTP interceptor; same row dates.
          const obj = checklistDatesFromApi(JSON.parse(data));
          this.assetManager.setDownloadedInspectionCollection(obj, false, true);
        }
      });
    }
  }

  public addTransferPointsStatusListener = () => {
    if (this.isConnectionAlive()) {
      this.hubConnection.on('utmautomaticpointssectionstatus', (data) => {
        switch (data.status) {
          case 'InProgress':
            switch (data.stage) {
              case 'CollectingData':
                console.log('CollectingData');
                break;
              case 'InsertingPoints':
                console.log('InsertingPoints -- Section', data.sectionId);
                console.log('InsertingPoints -- Region', data.regionId);
                console.log('InsertingPoints -- Asset', data.assetId);
                break;
              case 'Saving':
                console.log(data.message);
                console.log('saving');
                break;
              default:
                break;
            }
            break;
          case 'Success':
            this.iscollectionSet = true;
            console.log('Success');
            break;
          case 'Failed':
            // this.templateService.snack.open('Autoomatic InspectionPoints', 'Autoomatic InspectionPoints failed.', { duration: 4000 })
            console.log('Failed');
            break;
          default:
            break;
        }
      });
    }
  }

  public addTransferspreadhsheetStatusListener = () => {
    if (this.isConnectionAlive()) {
      this.hubConnection.on('transferspreadsheet', (data) => {
        switch (data.status) {
          case 'Started':
            break;
          case 'InProgress':
            console.log('in progress');
            console.log(data.message);
            break;
          case 'Success':
            console.log('Success');
            window.open(data.SpreadSheetBlobPath);
            this.notificationService.addFinishedNotification('Spreadsheet Generation')
            break;
          case 'PartialSuccess':
            console.log('PartialSuccess');
            window.open(data.SpreadSheetBlobPath);
            break;
          case 'Failed':
            this.notificationService.addFailedNotification('Spreadsheet Generation')
            console.log('Failed');
            break;
          default:
            break;
        }
      });
    }
  }

  public addTransferspreadhsheetImporterStatusListener = () => {
    if (this.isConnectionAlive()) {
      this.hubConnection.on('transferspreadsheetimport', (data) => {
        switch (data.status) {
          case 'InProgress':
            console.log('in progress');
            console.log(data.message);
            break;
          case 'Success':
            console.log('Success');
            window.open(data.spreadSheetBlobPath);
            this.notificationService.addFinishedNotification('Spreadsheet Generation')
            break;
          case 'Failed':
            this.notificationService.addFailedNotification('Spreadsheet Generation')
            console.log('Failed');
            break;
          default:
            break;
        }
      });
    }
  }

  public addTransferNeutralFileDataListener = () => {
    if (this.isConnectionAlive()) {
      this.hubConnection.on('transferneutrafiledata', (data) => {
        {
          console.log(data);
          window.open(data.neutralFileLink);
        }
      });
    }
  }

  public addNotificationsListener = () => {
    if (this.isConnectionAlive()) {
      this.hubConnection.on("notificationMessage", (notification: NotificationModel) => {
        console.log('🔔 [SignalR] notificationMessage RECEIVED →', notification?.title, '|', notification?.message, notification)
        this.handleNotification(notification)
        this.notificationService.addNotificationModel(notification)
      });
    }
  }

  public getConnectionId = () => {
    if (this.isConnectionAlive()) {
      this.hubConnection.invoke('getconnectionid').then((data) => {
        // console.log(data);
        this.connectionId = data;
      });
    }
  }

  public stopConnection(): void {
    if (!Util.isNullOrUndefined(this.hubConnection)) {
      this.hubConnection.stop();
    }
  }

  public cancelAutomaticInsertion(): void {
    this.hubConnection.invoke('AddToGroup');
  }

  public isConnectionAlive(): boolean {
    return this.hubConnection.state === SignalR.HubConnectionState.Connected;
  }

  public async joinGroup(id: string): Promise<void> {
    await this.hubConnection.invoke('AddToGroup', id);
  }

  public get IsCollectionSet() {
    return this.iscollectionSet;
  }

  public get CurrentCollection() {
    return this.currentCollection;
  }

  public getAcessToken() {
    return localStorage[SESSION_STORAGE.TOKEN];
  }

  private handleNotification(notification: NotificationModel) {
    switch (notification.title) {
      case "Automatic Changes":
      case "Change Workflow":
        if (notification.message == "Success") {
          this.assetManager.handleSuccessAfterBatchChanges()
        }
        break

      default:
        break
    }

  }
}
